export enum ChartMainAxisTypeEnum {
    days = 'DAYS',
    clubs = 'CLUBS',
    athletes = 'ATHLETES',
    segments = 'SEGMENTS'
}